import React from "react";

import "./button.sass";

const Button = ({
  title,
  borderColor = "transparent",
  borderWidth = "1px",
  backgroundColor = "#88cf4e",
  color = "#fff",
  icon,
  maxWidth = "200px",
  maxHeight,
  width = '100%',
  height = "48px",
  borderRadius = 10,
  fontSize = "14px",
  margin,
  fontWeight,
  loading,
  classs,
  ...others
}) => {
  return (
    <div
      className={`component-btn ${classs}`}
      style={{
        border: `${borderWidth} solid ${borderColor}`,
        // ? `1px solid ${borderColor}`
        // : "1px solid transparent",
        backgroundColor,

        maxWidth: maxWidth,
        maxHeight: maxHeight,
        width,
        height,
        borderRadius,
        fontSize,
        fontWeight,
        margin,
        // padding:"16px 24px"
      }}
      {...others}
    >
      {loading ? (
        <div className='dataloader'></div>
      ) : (
        <span style={{ color, marginLeft: icon ? 4 : 0 }}>{title}</span>
      )}
      {icon && (
        <img
          className='select-option-img'
          src={process.env.PUBLIC_URL + `/statics/images/arrow-down.svg`}
          alt='آیکن'
        />
      )}
    </div>
  );
};
export default Button;
